import ShowRateUs from './RateUs';
export default ShowRateUs;